import { render } from "./BomValidationsResults.vue?vue&type=template&id=615e8c37&scoped=true"
import script from "./BomValidationsResults.vue?vue&type=script&lang=js"
export * from "./BomValidationsResults.vue?vue&type=script&lang=js"

import "./BomValidationsResults.vue?vue&type=style&index=0&id=615e8c37&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615e8c37"]])

export default __exports__